
    import '/home/ec2-user/Youlify-Design/components/filter/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["filter-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/filter/index.zh-CN.md?type=demo')
};